import { render, staticRenderFns } from "./EventReviewPurchaseModalBody.vue?vue&type=template&id=5774fb8a&"
import script from "./EventReviewPurchaseModalBody.vue?vue&type=script&lang=js&"
export * from "./EventReviewPurchaseModalBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports